import {take, fork, all, call, put, takeLatest} from 'redux-saga/effects';
import * as constants from '../constants';
import * as api from '../services/api';
import * as actions from '../actions/action_auth';

function* watchLogin() {
    while (true) {
        const {payload} = yield take(constants.AUTH_LOGIN_REQUESTED);
        try {
            const response = yield call(api.authLogin, payload.username, payload.password);
            yield put(actions.loginSuccess(response.data));
        } catch (error) {
            yield put(actions.loginFailure(error));
        }
    }
}

function* watchLogout() {
    while (true) {
        yield take(constants.AUTH_LOGOUT);
        try {
            yield call(api.authLogout);
        } catch (error) {
            // No error
        }
    }
}

function* impersonate({payload}) {
    try {
        const response = yield call(api.authImpersonate, payload.id);
        yield put(actions.loginSuccess(response.data));
        yield put(actions.impersonateSuccess(response.data));
    } catch (error) {
        if (error.response && error.response.status === 401) {
            yield put(actions.logout());
        }
        yield put(actions.impersonateFailure(error));
    }
}

export default function* root() {
    yield all([
        fork(watchLogin),
        fork(watchLogout),
        takeLatest(constants.AUTH_IMPERSONATE_REQUESTED, impersonate),
    ]);
}
